export const Footer = () => (
  <footer data-testid="footer" className="border-t border-stone-200 bg-stone-100/50">
    <div className="max-w-7xl mx-auto px-6 md:px-10 pt-20 pb-10">
      <div className="font-serif text-7xl md:text-[11rem] leading-none tracking-tight text-stone-900/90 select-none">
        Stylo<span style={{ color: "#E63946" }}>.</span>
      </div>
      <div className="mt-10 flex flex-col md:flex-row md:items-center justify-between gap-6 border-t border-stone-200 pt-8">
        <p className="text-stone-500 text-sm max-w-sm">
          Precision Reimagined. A premium iPhone case with a seamlessly integrated stylus.
        </p>
        <div className="flex items-center gap-8 text-sm text-stone-500">
          <a href="#features" className="hover:text-stone-900 transition-colors">Design</a>
          <a href="#preorder" className="hover:text-stone-900 transition-colors">Pre-order</a>
          <a href="/admin" className="hover:text-stone-900 transition-colors" data-testid="footer-admin-link">Admin</a>
        </div>
      </div>
      <p className="mt-8 text-xs text-stone-400">© 2026 Stylo. CoCreate. All rights reserved.</p>
    </div>
  </footer>
);
